import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const clientServices = {
  statusUpdateSitePilotClient,
  getSingleSitePilotClient,
  getSitePilotClients,
};

// Status Update Client
async function statusUpdateSitePilotClient(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}statusUpdateSitePilotClient`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Get All Clients
async function getSitePilotClients(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSitePilotClients/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSitePilotClients/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Single Client Data
async function getSingleSitePilotClient(userId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleSitePilotClient/${userId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}